<template>
    <div class="shadow-wide bottom-0 fixed left-0 w-full bg-white z-50 lg:hidden">
        <a
            :href="'/quote/products/hospital?quoteId=' + quoteId"
            class="overflow-hidden transition-all duration-500 block"
            :class="activeMobile ? 'max-h-32' : 'max-h-0'"
        >
            <div
                class="bg-yellow-500 text-blue-500 py-2"
                :href="'/quote/products/hospital?quoteId=' + quoteId"
                @click="trackClick(promptText)"
            >
                <div class="container flex justify-between items-center">
                    <p class="font-medium">{{ promptText }}</p>
                    <!-- prettier-ignore -->
                    <svg class="icon--chevron transform -rotate-90 inline-block ml-3" role="img" focusable="false" aria-label="" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.8675 3.89223L1.77622 0.0241611L0.760306 1.04123L5.84334 6L11 1.06654L9.93346 0L5.8675 3.89223Z" fill="currentColor"></path></svg>
                </div>
            </div>
            <div
                class="flex justify-between text-blue-500 container py-4 small border-b border-grey-shadow"
            >
                <span>Summary</span>
                <div class="flex-shrink-0 font-medium">
                    <p
                        v-if="cartItems.hospital"
                        @click="trackClick(cartItems.hospital.product.name)"
                    >
                        <span
                            v-if="findRankColour(cartItems.hospital.product.name)"
                            class="inline-block w-3 h-3 mr-2 rounded-full"
                            :class="findRankColour(cartItems.hospital.product.name)"
                        ></span>
                        {{ cartItems.hospital.product.name }}
                    </p>
                    <p
                        v-if="cartItems.extras"
                        class="pl-6"
                        @click="trackClick(cartItems.extras.product.name)"
                    >
                        {{ cartItems.extras.product.name }}
                    </p>
                </div>
            </div>
        </a>
        <div class="container flex justify-between items-center py-5">
            <div @click="toggle('cart icon')">
                <CartIcon :count="count" variant="on-white" />
            </div>
            <div class="small">
                <button
                    v-if="activeMobile"
                    class="text-blue-500 flex items-center"
                    @click="toggle('close')"
                >
                    <!-- prettier-ignore -->
                    <svg class="icon--minus mr-3 w-4 h-4" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-label="">
                        <rect width="100%" height="2" x="0" y="50%" style="fill: currentColor;"/>
                    </svg>
                    Close
                </button>
                <button v-else class="text-blue-500 flex items-center" @click="toggle('open')">
                    <!-- prettier-ignore -->
                    <svg class="icon--plus mr-3 w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                         <path d="M13.25 6.25V7.75H0.75V6.25H13.25Z" fill="#004876"/>
                         <path d="M7.75 0.75V13.25H6.25V0.75H7.75Z" fill="#004876"/>
                     </svg>
                    Open
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import stateMixin from '@/../vue/cart/state-mixin.js';
import CartIcon from '@/../vue/cart/CartIcon.vue';
import * as track from '@/../vue/cart/tracking.js';

export default {
    components: {
        CartIcon
    },
    mixins: [stateMixin],
    props: {
        cartItems: {
            type: Object,
            required: true
        },
        quoteId: {
            type: String,
            required: true
        },
        promptText: {
            type: String,
            required: true
        }
    },
    methods: {
        toggle(clickText) {
            track.toggleCart(clickText, this.activeMobile);
            this.toggleCartMobile();
        },
        trackClick(text, eventName) {
            const url = `/quote/products/hospital?quoteId=${this.quoteId}`;
            track.linkClick(text, url, eventName);
        }
    }
};
</script>

<style scoped></style>
